import { NativeSelect } from '../components/app-ui/native-select';
import { Globe2 } from "../components/app-ui/icons/index";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import Brand from '../components/Brand';
import PlannerExperience from '../components/PlannerExperience';
import { useAuth } from '../contexts/AuthContext';
import type { Locale, PlannerMode } from '../types';

const startCopy = {
  en: { title: 'Let’s get away.', body: 'A little escape or a new adventure. Your call.', trips: 'My trips' },
  tr: { title: 'Yola çıkalım.', body: 'Küçük bir kaçamak ya da yepyeni bir gezi. Tam sana göre.', trips: 'Gezilerim' },
  sv: { title: 'Nu ger vi oss av.', body: 'En liten utflykt eller ett helt nytt äventyr. På ditt sätt.', trips: 'Mina resor' },
} satisfies Record<Locale, Record<string, string>>;

export default function Start() {
  const { t, i18n } = useTranslation();
  const { user, profile } = useAuth();
  const [planningStep, setPlanningStep] = useState(0);
  const [params] = useSearchParams();
  const locale = (['en', 'tr', 'sv'].includes(i18n.resolvedLanguage?.slice(0, 2) ?? '') ? i18n.resolvedLanguage!.slice(0, 2) : 'en') as Locale;
  const mode: PlannerMode = params.get('mode') === 'full_trip' ? 'full_trip' : 'quick_day';
  const copy = startCopy[locale];
  return <main className="start-page">
    <header className="start-header">
      <Link className="wordmark-link" to="/"><Brand /></Link>
      <div className="start-header-actions">
        <label className="site-language"><Globe2 aria-hidden /><span className="sr-only">{t('landing.languageLabel')}</span><NativeSelect value={locale} onChange={(event) => void i18n.changeLanguage(event.target.value)}><option value="en">EN</option><option value="tr">TR</option><option value="sv">SV</option></NativeSelect></label>
        {user && profile
          ? <Link className="button button-small button-ink start-account-link" to="/app/trips">{copy.trips}</Link>
          : <Link className="button button-small button-ink start-account-link" to="/login" state={{ from: '/app/home' }}>{t('auth.signIn')}</Link>}
      </div>
    </header>
    {planningStep === 0 && <section className="start-intro"><h1>{copy.title}</h1><p>{copy.body}</p></section>}
    <PlannerExperience variant="start" initialMode={mode} onStepChange={setPlanningStep} />
  </main>;
}
